export type PhoneCountry = {
  iso2: string;
  dialCode: string;
  name: string;
  emoji: string;
};

function flag(iso2: string): string {
  return iso2
    .toUpperCase()
    .split("")
    .map((c) => String.fromCodePoint(0x1f1e6 + c.charCodeAt(0) - 65))
    .join("");
}

// [iso2, dialCode, name]
const RAW: [string, string, string][] = [
  ["AD", "+376", "Andorra"],
  ["AE", "+971", "United Arab Emirates"],
  ["AF", "+93", "Afghanistan"],
  ["AG", "+1", "Antigua and Barbuda"],
  ["AI", "+1", "Anguilla"],
  ["AL", "+355", "Albania"],
  ["AM", "+374", "Armenia"],
  ["AO", "+244", "Angola"],
  ["AR", "+54", "Argentina"],
  ["AS", "+1", "American Samoa"],
  ["AT", "+43", "Austria"],
  ["AU", "+61", "Australia"],
  ["AW", "+297", "Aruba"],
  ["AZ", "+994", "Azerbaijan"],
  ["BA", "+387", "Bosnia and Herzegovina"],
  ["BB", "+1", "Barbados"],
  ["BD", "+880", "Bangladesh"],
  ["BE", "+32", "Belgium"],
  ["BF", "+226", "Burkina Faso"],
  ["BG", "+359", "Bulgaria"],
  ["BH", "+973", "Bahrain"],
  ["BI", "+257", "Burundi"],
  ["BJ", "+229", "Benin"],
  ["BM", "+1", "Bermuda"],
  ["BN", "+673", "Brunei"],
  ["BO", "+591", "Bolivia"],
  ["BR", "+55", "Brazil"],
  ["BS", "+1", "Bahamas"],
  ["BT", "+975", "Bhutan"],
  ["BW", "+267", "Botswana"],
  ["BY", "+375", "Belarus"],
  ["BZ", "+501", "Belize"],
  ["CA", "+1", "Canada"],
  ["CD", "+243", "DR Congo"],
  ["CF", "+236", "Central African Republic"],
  ["CG", "+242", "Republic of Congo"],
  ["CH", "+41", "Switzerland"],
  ["CI", "+225", "Ivory Coast"],
  ["CK", "+682", "Cook Islands"],
  ["CL", "+56", "Chile"],
  ["CM", "+237", "Cameroon"],
  ["CN", "+86", "China"],
  ["CO", "+57", "Colombia"],
  ["CR", "+506", "Costa Rica"],
  ["CU", "+53", "Cuba"],
  ["CV", "+238", "Cape Verde"],
  ["CW", "+599", "Curaçao"],
  ["CY", "+357", "Cyprus"],
  ["CZ", "+420", "Czech Republic"],
  ["DE", "+49", "Germany"],
  ["DJ", "+253", "Djibouti"],
  ["DK", "+45", "Denmark"],
  ["DM", "+1", "Dominica"],
  ["DO", "+1", "Dominican Republic"],
  ["DZ", "+213", "Algeria"],
  ["EC", "+593", "Ecuador"],
  ["EE", "+372", "Estonia"],
  ["EG", "+20", "Egypt"],
  ["ER", "+291", "Eritrea"],
  ["ES", "+34", "Spain"],
  ["ET", "+251", "Ethiopia"],
  ["FI", "+358", "Finland"],
  ["FJ", "+679", "Fiji"],
  ["FK", "+500", "Falkland Islands"],
  ["FM", "+691", "Micronesia"],
  ["FO", "+298", "Faroe Islands"],
  ["FR", "+33", "France"],
  ["GA", "+241", "Gabon"],
  ["GB", "+44", "United Kingdom"],
  ["GD", "+1", "Grenada"],
  ["GE", "+995", "Georgia"],
  ["GH", "+233", "Ghana"],
  ["GI", "+350", "Gibraltar"],
  ["GL", "+299", "Greenland"],
  ["GM", "+220", "Gambia"],
  ["GN", "+224", "Guinea"],
  ["GQ", "+240", "Equatorial Guinea"],
  ["GR", "+30", "Greece"],
  ["GT", "+502", "Guatemala"],
  ["GU", "+1", "Guam"],
  ["GW", "+245", "Guinea-Bissau"],
  ["GY", "+592", "Guyana"],
  ["HK", "+852", "Hong Kong"],
  ["HN", "+504", "Honduras"],
  ["HR", "+385", "Croatia"],
  ["HT", "+509", "Haiti"],
  ["HU", "+36", "Hungary"],
  ["ID", "+62", "Indonesia"],
  ["IE", "+353", "Ireland"],
  ["IL", "+972", "Israel"],
  ["IN", "+91", "India"],
  ["IQ", "+964", "Iraq"],
  ["IR", "+98", "Iran"],
  ["IS", "+354", "Iceland"],
  ["IT", "+39", "Italy"],
  ["JM", "+1", "Jamaica"],
  ["JO", "+962", "Jordan"],
  ["JP", "+81", "Japan"],
  ["KE", "+254", "Kenya"],
  ["KG", "+996", "Kyrgyzstan"],
  ["KH", "+855", "Cambodia"],
  ["KI", "+686", "Kiribati"],
  ["KM", "+269", "Comoros"],
  ["KN", "+1", "Saint Kitts and Nevis"],
  ["KP", "+850", "North Korea"],
  ["KR", "+82", "South Korea"],
  ["KW", "+965", "Kuwait"],
  ["KY", "+1", "Cayman Islands"],
  ["KZ", "+7", "Kazakhstan"],
  ["LA", "+856", "Laos"],
  ["LB", "+961", "Lebanon"],
  ["LC", "+1", "Saint Lucia"],
  ["LI", "+423", "Liechtenstein"],
  ["LK", "+94", "Sri Lanka"],
  ["LR", "+231", "Liberia"],
  ["LS", "+266", "Lesotho"],
  ["LT", "+370", "Lithuania"],
  ["LU", "+352", "Luxembourg"],
  ["LV", "+371", "Latvia"],
  ["LY", "+218", "Libya"],
  ["MA", "+212", "Morocco"],
  ["MC", "+377", "Monaco"],
  ["MD", "+373", "Moldova"],
  ["ME", "+382", "Montenegro"],
  ["MG", "+261", "Madagascar"],
  ["MH", "+692", "Marshall Islands"],
  ["MK", "+389", "North Macedonia"],
  ["ML", "+223", "Mali"],
  ["MM", "+95", "Myanmar"],
  ["MN", "+976", "Mongolia"],
  ["MO", "+853", "Macao"],
  ["MP", "+1", "Northern Mariana Islands"],
  ["MR", "+222", "Mauritania"],
  ["MS", "+1", "Montserrat"],
  ["MT", "+356", "Malta"],
  ["MU", "+230", "Mauritius"],
  ["MV", "+960", "Maldives"],
  ["MW", "+265", "Malawi"],
  ["MX", "+52", "Mexico"],
  ["MY", "+60", "Malaysia"],
  ["MZ", "+258", "Mozambique"],
  ["NA", "+264", "Namibia"],
  ["NC", "+687", "New Caledonia"],
  ["NE", "+227", "Niger"],
  ["NG", "+234", "Nigeria"],
  ["NI", "+505", "Nicaragua"],
  ["NL", "+31", "Netherlands"],
  ["NO", "+47", "Norway"],
  ["NP", "+977", "Nepal"],
  ["NR", "+674", "Nauru"],
  ["NZ", "+64", "New Zealand"],
  ["OM", "+968", "Oman"],
  ["PA", "+507", "Panama"],
  ["PE", "+51", "Peru"],
  ["PF", "+689", "French Polynesia"],
  ["PG", "+675", "Papua New Guinea"],
  ["PH", "+63", "Philippines"],
  ["PK", "+92", "Pakistan"],
  ["PL", "+48", "Poland"],
  ["PR", "+1", "Puerto Rico"],
  ["PS", "+970", "Palestine"],
  ["PT", "+351", "Portugal"],
  ["PW", "+680", "Palau"],
  ["PY", "+595", "Paraguay"],
  ["QA", "+974", "Qatar"],
  ["RO", "+40", "Romania"],
  ["RS", "+381", "Serbia"],
  ["RU", "+7", "Russia"],
  ["RW", "+250", "Rwanda"],
  ["SA", "+966", "Saudi Arabia"],
  ["SB", "+677", "Solomon Islands"],
  ["SC", "+248", "Seychelles"],
  ["SD", "+249", "Sudan"],
  ["SE", "+46", "Sweden"],
  ["SG", "+65", "Singapore"],
  ["SI", "+386", "Slovenia"],
  ["SK", "+421", "Slovakia"],
  ["SL", "+232", "Sierra Leone"],
  ["SM", "+378", "San Marino"],
  ["SN", "+221", "Senegal"],
  ["SO", "+252", "Somalia"],
  ["SR", "+597", "Suriname"],
  ["SS", "+211", "South Sudan"],
  ["ST", "+239", "São Tomé and Príncipe"],
  ["SV", "+503", "El Salvador"],
  ["SY", "+963", "Syria"],
  ["SZ", "+268", "Eswatini"],
  ["TD", "+235", "Chad"],
  ["TG", "+228", "Togo"],
  ["TH", "+66", "Thailand"],
  ["TJ", "+992", "Tajikistan"],
  ["TL", "+670", "Timor-Leste"],
  ["TM", "+993", "Turkmenistan"],
  ["TN", "+216", "Tunisia"],
  ["TO", "+676", "Tonga"],
  ["TR", "+90", "Turkey"],
  ["TT", "+1", "Trinidad and Tobago"],
  ["TV", "+688", "Tuvalu"],
  ["TW", "+886", "Taiwan"],
  ["TZ", "+255", "Tanzania"],
  ["UA", "+380", "Ukraine"],
  ["UG", "+256", "Uganda"],
  ["US", "+1", "United States"],
  ["UY", "+598", "Uruguay"],
  ["UZ", "+998", "Uzbekistan"],
  ["VA", "+39", "Vatican City"],
  ["VC", "+1", "Saint Vincent and the Grenadines"],
  ["VE", "+58", "Venezuela"],
  ["VG", "+1", "British Virgin Islands"],
  ["VI", "+1", "US Virgin Islands"],
  ["VN", "+84", "Vietnam"],
  ["VU", "+678", "Vanuatu"],
  ["WS", "+685", "Samoa"],
  ["XK", "+383", "Kosovo"],
  ["YE", "+967", "Yemen"],
  ["ZA", "+27", "South Africa"],
  ["ZM", "+260", "Zambia"],
  ["ZW", "+263", "Zimbabwe"],
];

export const ALL_PHONE_COUNTRIES: PhoneCountry[] = RAW.map(([iso2, dialCode, name]) => ({
  iso2,
  dialCode,
  name,
  emoji: flag(iso2),
}));
